import React, { useState } from "react";
import {
  Card,
  Table,
  Button,
  Dropdown,
  Form,
  Pagination,
} from "react-bootstrap";
import { FaPlus, FaFilter, FaRedo, FaTrashAlt, FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const LibraryUsersTable = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([
    { name: "John Doe", owner: "Admin", lastModified: "2024-12-25", modifiedBy: "Admin", status: "Active" },
    { name: "Jane Smith", owner: "Admin", lastModified: "2024-12-24", modifiedBy: "Admin", status: "Inactive" },
    // Add more data as needed
  ]);
  const navigate  = useNavigate();
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleDelete = (index) => {
    const newData = [...data];
    newData.splice(index, 1);
    setData(newData);
  };

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="p-3">
      <h4>Library Users</h4>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Button variant="primary" className="d-flex align-items-center" onClick={() => navigate("/organisation/library/add-user")}>
          <FaPlus className="me-2" /> + User
        </Button>
        <div className="d-flex align-items-center">
          <Button variant="light" className="me-2">
            <FaFilter />
          </Button>
          <Button variant="light" className="me-2">
            <FaRedo />
          </Button>
          <div className="position-relative">
            <Form.Control
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              style={{ width: "200px", borderRadius: "20px", paddingLeft: "35px" }}
            />
            <FaFilter
              style={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      </div>
      <Card>
        <Card.Body>
          <div >
            <Table striped bordered hover style={{ overflow: "auto" }}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Owner</th>
                  <th>Last Modified</th>
                  <th>Modified By</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.owner}</td>
                    <td>{item.lastModified}</td>
                    <td>{item.modifiedBy}</td>
                    <td>
                      <span
                        className={`badge ${
                          item.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td>
                      <Dropdown container="body">
                        <Dropdown.Toggle
                          variant="light"
                          size="sm"
                          className="border-0"
                        >
                          Actions
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end" style={{ zIndex: 1050 }}>
                          <Dropdown.Item>
                            <FaEdit className="me-2 text-primary" /> Edit
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => handleDelete(index)}>
                            <FaTrashAlt className="me-2 text-danger" /> Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
                {!filteredData.length && (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No results found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span>
              Showing {filteredData.length} of {data.length} entries
            </span>
            <Pagination>
              <Pagination.Prev />
              <Pagination.Item active>1</Pagination.Item>
              <Pagination.Item>2</Pagination.Item>
              <Pagination.Next />
            </Pagination>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default LibraryUsersTable;
